<template>
  <div class="notice-management">
    <!-- 页面头部 -->
    <div class="common-level-rail">
      <h2>公告管理</h2>
      <div class="right-buttons">
        <el-button size="small" icon="el-icon-back" @click="goBack">返回</el-button>
        <el-button size="small" icon="el-icon-plus" type="primary" @click="addNotice">添加公告</el-button>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="searchForm.status" placeholder="公告状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="searchForm.title" placeholder="公告标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 公告列表 -->
    <div class="table-wrap">
      <el-table size="small" :data="noticeList" border style="width: 100%" v-loading="loading">
        <el-table-column prop="title" label="公告标题" min-width="200">
          <template slot-scope="scope">
            <span class="notice-title" @click="viewNotice(scope.row)">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="editNotice(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteNotice(scope.row)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber">
      </el-pagination>
    </div>

    <!-- 添加/编辑公告弹窗 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="800px"
      :close-on-click-modal="false">
      
      <el-form :model="noticeForm"  ref="noticeForm" label-width="100px">
        <el-form-item label="公告标题" prop="title">
          <el-input 
            v-model="noticeForm.name" 
            placeholder="请输入公告内容"
            maxlength="100"
            show-word-limit>
          </el-input>
        </el-form-item>
        
        
        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="noticeForm.sort" 
            :min="0" 
            :max="999"
            controls-position="right">
          </el-input-number>
          <div class="form-tips">数字越小越靠前</div>
        </el-form-item>
        
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitNotice" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 公告详情弹窗 -->
    <el-dialog 
      title="公告详情" 
      :visible.sync="detailVisible" 
      width="700px">
      <div class="notice-detail">
        <h3 class="detail-title">{{ currentNotice.title }}</h3>
        <div class="detail-meta">
          <span>创建时间：{{ currentNotice.create_time }}</span>
          <span style="margin-left: 20px;">状态：{{ currentNotice.status ? '启用' : '禁用' }}</span>
        </div>
        <div class="detail-content">{{ currentNotice.content }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SupplyApi from '@/api/supply.js';

export default {
  data() {
    return {
      loading: false,
      submitLoading: false,
      supply_id: 0,
      noticeList: [],
      curPage: 1,
      pageSize: 20,
      totalDataNumber: 0,
      
      // 搜索表单
      searchForm: {
        status: '-1',
        title: ''
      },
      
      // 弹窗控制
      dialogVisible: false,
      detailVisible: false,
      dialogTitle: '添加公告',
      
      // 表单数据
      noticeForm: {
        supply_notice_id: 0,
        name:'',
        sort: 50,
        status: 1
      },
      
      // 当前查看的公告
      currentNotice: {},
    
     
    };
  },
  
  created() {
    this.supply_id = this.$route.query.supply_id;
    if (!this.supply_id) {
      this.$message.error('缺少企业ID');
      this.goBack();
      return;
    }
    this.getNoticeList();
  },
  
  methods: {
    // 获取公告列表
    getNoticeList() {
      this.loading = true;
      const params = {
        ...this.searchForm,
        supply_id: this.supply_id,
        page: this.curPage,
        list_rows: this.pageSize
      };
      
      // 使用现有的SupplyApi，您需要在SupplyApi中添加公告相关的方法
      SupplyApi.getNoticeList(params, true)
        .then(res => {
          this.loading = false;
          if (res.code === 1) {
            this.noticeList = res.data.list.data || [];
            this.totalDataNumber = res.data.list.total || 0;
          } else {
            this.$message.error(res.msg || '获取公告列表失败');
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('获取公告列表失败');
        });
    },
    
    // 搜索
    onSearch() {
      this.curPage = 1;
      this.getNoticeList();
    },
    
    // 添加公告
    addNotice() {
      this.dialogTitle = '添加公告';
      this.noticeForm = {
        supply_notice_id: 0,
        title: '',
        content: '',
        sort: 50,
        status: 1
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.noticeForm) {
          this.$refs.noticeForm.clearValidate();
        }
      });
    },
    
    // 编辑公告
    editNotice(row) {
      this.dialogTitle = '编辑公告';
      this.noticeForm = {
        supply_notice_id: row.supply_notice_id,
        name: row.name,
        sort: row.sort
      };
      this.dialogVisible = true;
    },
    
    // 提交公告
    submitNotice() {
      this.$refs.noticeForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = {
            ...this.noticeForm,
            supply_id: this.supply_id
          };
          
          const api = this.noticeForm.supply_notice_id ? SupplyApi.editNotice : SupplyApi.addNotice;
          
          api(params, true)
            .then(res => {
              this.submitLoading = false;
              if (res.code === 1) {
                this.$message.success(this.noticeForm.supply_notice_id ? '编辑成功' : '添加成功');
                this.dialogVisible = false;
                this.getNoticeList();
              } else {
                this.$message.error(res.msg || '操作失败');
              }
            })
            .catch(error => {
              this.submitLoading = false;
              this.$message.error('操作失败');
            });
        }
      });
    },
    
    // 查看公告详情
    viewNotice(row) {
      this.currentNotice = { ...row };
      this.detailVisible = true;
    },
    
    // 删除公告
    deleteNotice(row) {
      this.$confirm('确定要删除该公告吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        SupplyApi.deleteNotice({
          notice_id: row.supply_notice_id
        }, true).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功');
            this.getNoticeList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      });
    },
    
    // 修改状态
    changeStatus(row) {
      SupplyApi.changeNoticeStatus({
        notice_id: row.supply_notice_id,
        status: row.status
      }, true).then(res => {
        if (res.code === 1) {
          this.$message.success('状态修改成功');
        } else {
          this.$message.error(res.msg || '状态修改失败');
          // 恢复原状态
          row.status = row.status ? 0 : 1;
        }
      }).catch(error => {
        this.$message.error('状态修改失败');
        // 恢复原状态
        row.status = row.status ? 0 : 1;
      });
    },
    
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.curPage = 1;
      this.getNoticeList();
    },
    
    handleCurrentChange(val) {
      this.curPage = val;
      this.getNoticeList();
    },
    
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.notice-management {
  padding: 20px;
}

.common-level-rail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.right-buttons {
  display: flex;
  gap: 10px;
}

.notice-title {
  color: #409EFF;
  cursor: pointer;
}

.notice-title:hover {
  text-decoration: underline;
}

.notice-detail {
  padding: 0 10px;
}

.detail-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.detail-meta {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.detail-content {
  line-height: 1.6;
  min-height: 200px;
  white-space: pre-wrap;
  word-break: break-all;
}

.form-tips {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.table-wrap {
  margin-bottom: 20px;
}

.pagination {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/notice/index.vue